module.exports = __webpack_public_path__ + "img/b42f191.jpg";